import React from 'react';
import { Link } from '@inertiajs/react';
import Callout from './Callout';
import type { ClientMeta } from './clients';
import { topicPath } from './topics';
import { inlineCode, pageTitle } from './ui';

// Claude Desktop is two things: the Code tab runs Claude Code and connects;
// the custom connectors in chat cannot. No three steps here (spec §5.3).
const DesktopTopic: React.FC<{ client: ClientMeta }> = ({ client }) => (
  <>
    <h1 className={pageTitle}>{client.label}</h1>
    <p className="mt-1.5 text-sm text-gray-700">{client.route}</p>
    <div className="mt-5 space-y-3">
      <Callout tone="info" title="Code tab 能接">
        Desktop 的 Code tab 跑的就是 Claude Code，和命令行版读同一份 <code className={inlineCode}>~/.claude.json</code> 与{' '}
        <code className={inlineCode}>~/.claude/settings.json</code>
        。照 Claude Code 那页在终端里接一次，Code tab 里就能直接用；Stop hook 装在 settings.json 里，也一样生效。{' '}
        <Link href={topicPath('claude-code')} className="text-blue-600">
          看 Claude Code 那页 →
        </Link>
      </Callout>
      <Callout tone="warn" title="聊天里的自定义连接器接不上">
        自定义连接器由 Anthropic 云端连出去，对话框里只有一个 URL 和 OAuth 的 client id ——{' '}
        <strong>没有任何地方能放 Authorization 头</strong>，而 asaptodo 的授权服务器不做动态客户端注册，OAuth
        那条路同样走不通。要在 Desktop 里用 asaptodo，走上面的 Code tab。
      </Callout>
    </div>
  </>
);

export default DesktopTopic;
